<div class="side-menu-container">
  @for (menu of menuList(0); track $index) {
  <div
    class="main-menu-container menu-hover"
    [ngClass]="{ 'menu-active': isParentActive(menu) }"
    [routerLink]="!menu.hasSubMenu ? menu.routerLink : null"
    routerLinkActive="active"
  >
    <a
      (click)="handleMenuClick(menu)"
      class="menu-link-container"
      [matTooltip]="menuCollapsed ? menu.title : ''"
      matTooltipPosition="right"
    >
      <div class="menu-icon-and-title">
        <img
          class="svg-icon"
          src="{{ 'assets/icons/' + menu.icon + '.svg' }}"
          alt="main-menu"
        />
        @if (!menuCollapsed) {
        <span class="menu-title"> {{ menu.title }} </span>
        }
      </div>
      <mat-icon *ngIf="menu.hasSubMenu">
        {{ menu.subMenu ? "expand_less" : "expand_more" }}
      </mat-icon>
    </a>
  </div>

  <div class="sub-menu-container">
    <div class="vertical-line"></div>
    <div class="submenu" *ngIf="menu.subMenu" [class.open]="menu.subMenu">
      @for (sub of subMenu(menu.id); track $index) {
      <a
        class="sub-menu-list menu-hover"
        [ngClass]="{ 'sub-menu-collapsed-list': menuCollapsed }"
        mat-button
        routerLinkActive="active"
        [routerLink]="sub.routerLink"
        [matTooltip]="menuCollapsed ? sub.title : ''"
        matTooltipPosition="right"
        (click)="onSubMenuClick()"
      >
        <img
          class="svg-icon"
          src="{{ 'assets/icons/' + sub.icon + '.svg' }}"
          alt="main-menu"
        />
        @if (!menuCollapsed) {
        <span class="sub-menu-title">{{ sub.title }}</span>
        }
      </a>
      }
    </div>
  </div>
  }
</div>
